module.exports = __webpack_public_path__ + "img/myDsp.fb9ae790.jpg";